import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { Page } from '@/components/_shared/Page';
import { ViewReservationErrorFallback } from '@/components/reservation/ViewReservationErrorFallback';
import { ViewReservationSkeleton } from '@/components/reservation/ViewReservationSkeleton';
import { ViewWaitlistContentWrapper } from '@/components/waitlist/ViewWaitlistContentWrapper';

import { styles } from './styles';
import type { ViewWaitlistScreenProps } from './types';

const ViewWaitlistScreen: React.FC<ViewWaitlistScreenProps> = ({
  waitlistCustomerId,
  slotId,
}) => {
  const { reset } = useQueryErrorResetBoundary();

  return (
    <Page edges={['top', 'left', 'right']} style={styles.container}>
      <ErrorBoundary
        FallbackComponent={ViewReservationErrorFallback}
        onReset={reset}
      >
        <Suspense fallback={<ViewReservationSkeleton />}>
          <ViewWaitlistContentWrapper
            waitlistCustomerId={waitlistCustomerId}
            slotId={slotId}
          />
        </Suspense>
      </ErrorBoundary>
    </Page>
  );
};

ViewWaitlistScreen.displayName = 'ViewWaitlistScreen';
export { ViewWaitlistScreen };
